module.exports = __webpack_public_path__ + "static/media/BauPro-Bold.5f9f3c90.woff";